import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { IReduxState } from '../../../../../configureStore';
import type { IRequestGetOne } from '../../../../interfaces/requestGetOne';
import { SomnologyOrganizationType } from '../../../../../../common/enums/somnologyOrganizationType';
import { fetchJson } from '../../../../../store/fetch';
import { translateKey } from '../../../../../translate';
import { Button } from '../../../../elements/common';

interface IOsasoCreateRequestOsasc2ButtonProps {
    reloadProcess: () => Promise<void>;
    request: IRequestGetOne;
}

export function OsasoCreateRequestOsasc2Button(props: IOsasoCreateRequestOsasc2ButtonProps) {
    const [canCreateRequestOsasc2, setCanCreateRequestOsasc2] = useState(false);
    const organizationId = useSelector((state: IReduxState) => state.authentication.organizationId);

    useEffect(() => {
        if (
            props.request.customControlData?.manuallyRequested &&
            !props.request.customControlData?.requestIdOsasc2 &&
            props.request.customControlData?.somnologyOrganizationType ===
                SomnologyOrganizationType.ksyosMedicalCenter &&
            organizationId === props.request.recipientOrganizationId
        ) {
            countNotCancelledManuallyRequestedOsasc2();
        } else {
            setCanCreateRequestOsasc2(false);
        }
    }, [props.request]);

    if (!canCreateRequestOsasc2) {
        return null;
    }

    return (
        <Button
            automation="createOsasc2"
            color="secondary"
            large
            onClick={async () => {
                await createOsasc2();
            }}
        >
            {translateKey('osas.startOsasc2')}
        </Button>
    );

    async function createOsasc2() {
        await fetchJson(`/api/requests/${props.request.id}/createRequestOsasc2`, 'POST', {});
        await props.reloadProcess();
    }

    async function countNotCancelledManuallyRequestedOsasc2() {
        const result = await fetchJson(
            `/api/requests/countNotCancelledManuallyRequestedOsasc2?patientId=${props.request.patientId}&osasoRequestId=${props.request.id}`,
            'GET'
        );
        setCanCreateRequestOsasc2(result.json.total === 0);
    }
}
